export const ApplicationMenuPermissions = ['GOD_MODE', 'APPLICATION_MENU_ACCESS'];

export const ProjectTrackerPermissions = ['GOD_MODE', 'PROJECT_TRACKER_ACCESS'];

export const ProcurementPOPermissions = ['GOD_MODE', 'PROCUREMENT_PO_ACCESS'];

export const ProcurementRFQPermissions = ['GOD_MODE', 'PROCUREMENT_RFQ_ACCESS'];

export const VendorMgmtPermissions = ['GOD_MODE', 'VENDOR_MANAGEMENT_ACCESS'];

export const ProjectAnalyticsPermissions = ['GOD_MODE', 'PROJECT_ANALYTICS_ACCESS'];

export const POSummaryPermissions = ['GOD_MODE', 'PO_SUMMARY_ACCESS'];

export const PiplineEstimatorPermissions = ['GOD_MODE', 'PIPELINE_ESTIMATOR_ACCESS'];

export const SparrowPermissions = ['GOD_MODE', 'SPARROW_AI_ACCESS'];

export const TutorialPermissions = ['GOD_MODE', 'TUTORIAL_ACCESS'];

export const AdminPermissions = ['GOD_MODE'];

export const ProcurementAdminPermissions = ['GOD_MODE', 'PROCUREMENT_ADMIN'];

export const ReleaseNotesPermissions = ['GOD_MODE', 'RELEASE_NOTES_ACCESS'];
